export default "<cc-page-header></cc-page-header>\n<router-outlet></router-outlet>\n<p-toast></p-toast>"